module.exports = __webpack_public_path__ + "static/img/img_register_success.10d8f18c.png";